export { default as ApplicationsDrawer } from './ApplicationsDrawer'
